const Constants = require('Constants');

let Backbone = require('backbone');
let _ = require('underscore');
let offlineStorage = require('offline-storage');

let StudentResponse = Backbone.Model.extend({
  urlRoot: window.APP_CONFIG.BACKEND_HOST + '/students/api/responses/',

  defaults: {
    multi_response: false,
  },

  save: function(attributes, options) {
    if (_.isObject(attributes)) {
      this.set(attributes);
    }

    let selectedIds = _.pluck(this.get('selection_answers'), 'answer_id');
    this.set('answer_ids', selectedIds.join(','));

    if (this.has('text_answers') && this.get('text_answers').length > 0) {
      this.set('answer_text', this.get('text_answers')[0].answer_text);
    }

    if (this.has('id')) {
      this.set({ id: null }, { silent: true });
      // this.urlRoot += this.get("id");
    }

    return offlineStorage.save(this, attributes, {
      success: function(data, request) {
        if (_.isObject(options) && _.isFunction(options.success)) {
          options.success(data, request);
        }
      },
      error: function(model, err) {
        if (_.isObject(options) && _.isFunction(options.error)) {
          options.error(err);
        }
      },
    });
  },

  hasAnswer: function() {
    let hasText =
      this.has('text_answers') &&
      this.get('text_answers').length > 0 &&
      !_.isUndefined(this.get('text_answers')[0].answer_text) &&
      this.get('text_answers')[0].answer_text.length > 0 &&
      !/^\s+$/.test(this.get('text_answers')[0].answer_text);

    let hasSelections =
      this.has('selection_answers') && this.get('selection_answers').length > 0;
    return hasText || hasSelections;
  },
});

module.exports = StudentResponse;
